import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { CarouselModule } from "ngx-owl-carousel-o";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxYoutubePlayerModule } from "ngx-youtube-player";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BackTopComponent } from "./components/back-top/back-top.component";
import { WhatsappComponent } from "./components/whatsapp/whatsapp.component";

@NgModule({
  declarations: [BackTopComponent, WhatsappComponent],
  imports: [
    CommonModule,
    ScrollToModule.forRoot(),
    CarouselModule,
    NgbAccordionModule,
    NgxYoutubePlayerModule,
    TooltipModule,
  ],
  exports: [BackTopComponent, WhatsappComponent],
})
export class SharedModule {}
